export const Fächer = [
    {
        name: "Deutsch"
    },
    {
        name: "Englisch"
    },
    {
        name: "Mathe"
    },
    {
        name: "Französisch"
    },
    {
        name: "Kunst"
    },
    {
        name: "Geografie"
    },
    {
        name: "Geschichte"
    },
    {
        name: "Sport"
    },
    {
        name: "Biologie"
    }
]